const ns_multicolumn = {

  ResizeCards: () => {
    const cards = document.querySelectorAll('.multicolumn--card-style-circle .multicolumn-card');
    const mqList = window.matchMedia('(min-width: 920px) and (max-width: 1164px)');
  
    if (mqList.matches) {
      cards.forEach(card => {
        const cardWidth = card.offsetWidth;
        card.style.height = `${cardWidth}px`;
      })
    } else {
      cards.forEach(card => {
        card.style.removeProperty('height');
      })
    }
  },
  CircleTheme: '.multicolumn--card-style-circle'

};

if (document.querySelector(ns_multicolumn.CircleTheme)) {
  document.addEventListener('DOMContentLoaded', () => {
    ns_multicolumn.ResizeCards();
  })
  window.addEventListener('resize', e => {
    ns_multicolumn.ResizeCards();
  });
}